import _Switch from './Switch';

import './style/index.js';

export type { SwitchProps } from './Switch';
export * from './type';

export const Switch = _Switch;
export default Switch;
